const getTipoColaborador = permissao => {
    const tipos = {
        '1': 'vendedor',
        '2': 'coordenador',
        '3': 'supervisor',
        '8': 'gerente'
    };

    return tipos[permissao] || 'vendedor';
};

export default getTipoColaborador;
